import React, { useState } from 'react';
import { isValidUntestedReason, MIN_UNTESTED_REASON_LENGTH } from '../../utils/untestedReason';

export default function UntestedConfirmModal({ itemName, onConfirm, onCancel }) {
  const [reason, setReason] = useState('');
  const valid = isValidUntestedReason(reason);
  const count = reason.trim().length;

  return (
    <div role="dialog" aria-modal="true" style={overlay}>
      <div style={card}>
        <h3 style={{ margin: '0 0 8px' }}>Do you really want to save this as untested?</h3>
        <p style={{ margin: '0 0 12px', color: '#78716C', fontSize: 14 }}>
          {itemName ? `"${itemName}" ` : 'This item '}
          will be listed without any functional verification. Please explain why.
        </p>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Explain why this item is being saved untested…"
          rows={4}
          style={textarea}
        />
        <div style={{ fontSize: 12, color: valid ? '#3BB273' : '#B45309', margin: '4px 0 12px' }}>
          {count}/{MIN_UNTESTED_REASON_LENGTH} minimum
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button type="button" onClick={onCancel} style={btnGhost}>Cancel</button>
          <button
            type="button"
            disabled={!valid}
            onClick={() => onConfirm(reason.trim())}
            style={{ ...btnPrimary, opacity: valid ? 1 : 0.5, cursor: valid ? 'pointer' : 'not-allowed' }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 };
const card = { background: '#fff', borderRadius: 10, padding: 20, width: 440, maxWidth: '90vw' };
const textarea = { width: '100%', boxSizing: 'border-box', padding: 8, borderRadius: 6,
  border: '1px solid #E7E5E4', fontFamily: 'inherit', fontSize: 14, resize: 'vertical' };
const btnGhost = { padding: '8px 14px', borderRadius: 6, border: '1px solid #E7E5E4', background: '#fff', cursor: 'pointer' };
const btnPrimary = { padding: '8px 14px', borderRadius: 6, border: 'none', background: '#3BB273', color: '#fff' };
